<template>
  <section
    :class="{
      'relative overflow-hidden': true,
      rounded: rounded,
      'max-h-72 overflow-y-auto': scrollable,
    }"
    data-id="code-samples"
    :data-lang="lang"
  >
    <span class="absolute right-1 top-1" v-if="copy">
      <CopyButton size="xs" :value="code" />
    </span>
    <pre
      v-html="code"
      :class="'language-' + lang + ' my-0 text-xs leading-relaxed'"
    />
  </section>
</template>
<script setup lang="ts">
import prismjs from 'prismjs';
import '../../lib/services/prismImports';
import { computed } from 'vue';
import { useStore3 } from '../../store/main';
import CopyButton from '../../components/CopyButton.vue';
import { getLogger } from '../../lib/services/getLogger';

const { highlight, languages } = prismjs;
const log = getLogger('CodeView');
const store3 = useStore3();

const props = withDefaults(
  defineProps<{
    copy?: boolean;
    rounded?: boolean;
    value: string;
    lang?: string;
    scrollable?: boolean;
  }>(),
  { lang: 'html', rounded: true },
);

const valueF = computed(() => {
  if (store3?.regressionTest) {
    return 'test-code';
  } else {
    return props.value;
  }
});
const code = computed(() => {
  const v = valueF.value;
  const l = languages[props.lang];
  const ln = props.lang;
  log(`Format: "${v}" | "${l}" | "${ln}"`);
  return highlight(v!, l, ln); // returns html
});
</script>
